<template>
  <div>
    <section class="page-content">
      <div class="row">
        <div class="col-md-12 special-title">
          <form action @submit.prevent="next">
            <article class="d-flex form-heading title-section form-section row mr-0 ml-0 ax-app-header-section">
              <p class="form-title text-center col-md-4" style="font-size: 15px;">
                OREP Insurance Services, LLC <br />
                NY Lic.# EX1721672R<br />
                6353 El Cajon Blvd, Suite 124-605<br/>
                San Diego, CA 92115
              </p>
              <p class="form-title text-center col-md-4" style="font-size: 20px;">
                NOTICE OF EXCESS LINE PLACEMENT
              </p>
              <p class="form-title text-center col-md-4" style="font-size: 15px;">
                Date: {{ formattedCurrentDate() }}
              </p>




            </article>
            <article class="input-section form-section">
              <div >
                <p class="mb-3 ar-sl-disclosure">
                  
                    Consistent  with  the  requirements  of  the  New  York  Insurance  Law  and  Regulation  41
                    <strong>
                      {{ standardApplication.nameOfApplicant }}</strong>  is  hereby  advised  that  all  or  a  portion  of  the  required  coverages  have  been placed by Isaac Peck
                    with insurers not authorized to do an insurance business in New York and which are not subject to supervision by this State.
                    Placements with unauthorized insurers can only be made under one of the following circumstances:
                  </p>
                <p class="mb-3 ar-sl-disclosure" style="margin-left: 20px">
                  
                    a) A diligent effort was first made to place the required insurance with companies authorized in New
                    York to write coverages of the kind requested; or
                  </p>
                <p class="mb-3 ar-sl-disclosure" style="margin-left: 20px">
                  
                    b) NO diligent effort was required because i) the coverage qualifies as an “Export List” risk, or ii) the
                    insured qualifies as an “Exempt Commercial Purchaser.”
                  </p>
                <p class="mb-3 ar-sl-disclosure">
                  
                    Policies issued by such unauthorized insurers may not be subject to all of the regulations of the
                    Superintendent of Financial Services pertaining to policy forms. In the event of insolvency of the
                    unauthorized insurers, losses will not be covered by any New York State security fund.
                  </p>

                <p class="mb-3 ar-sl-disclosure text-center" style="margin-top: 20px;margin-bottom: 50px">
                  
                    <strong>
                      TOTAL COST FORM (NON TAX ALLOCATED PREMIUM TRANSACTION)
                    </strong>
                  </p>

                <p class="mb-3 ar-sl-disclosure">
                  
                    In consideration of your placing my insurance as described in the policy referenced below, I agree to pay the
                    total cost below which includes all premiums, inspection charges (1) and a service fee that includes taxes,
                    stamping fees, and (if indicated) a fee (1) for compensation in addition to commissions received, and other
                    expenses (1) .
                  </p>
                <p class="mb-3 ar-sl-disclosure" > I further understand and agree that all fees, inspection charges and other expenses denoted by (1) are fully
                  earned from the inception date of the policy and are non-refundable regardless of whether said policy is
                  cancelled. Any policy changes which generate additional premium are subject to additional tax and stamping
                  fee charges.</p>
                <div class="row">
                  <div class="col-md-6">
                    <section class="mt-3" >
                      <p class="mb-3 ar-sl-disclosure" > Re: Policy No.: </p>
                    </section>
                  </div>
                  <div class="col-md-6">
                    <section class="mt-3" >
                      <p class="mb-3 ar-sl-disclosure" > </p>
                    </section>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <section class="notice-form-date-fl">
                      <p class="mb-3 ar-sl-disclosure" > Policy Premium</p>
                      <p class="mb-3 ar-sl-disclosure" >
                        <strong>
                          Insurer Imposed Charges:
                        </strong>
                      </p>
                      <p class="mb-3 ar-sl-disclosure" >
                        Policy Fees (1)
                      </p>
                      <p class="mb-3 ar-sl-disclosure" >
                        Inspection Fees (1)
                      </p>
                      <p class="mb-3 ar-sl-disclosure" >
                        Total Taxable Charges
                      </p>
                    </section>
                  </div>
                  <div class="col-md-6">
                    <section class="notice-form-date-fl">
                      <p class="mb-3 ar-sl-disclosure text-left" > <strong>{{ '$' }}</strong></p>
                      <p class="mb-3 ar-sl-disclosure text-left" >
                        <br/>
                      </p>
                      <p class="mb-3 ar-sl-disclosure text-left" >
                        $
                      </p>
                      <p class="mb-3 ar-sl-disclosure text-left" >
                        $__________________________
                      </p>
                      <p class="mb-3 ar-sl-disclosure text-left" >
                      </p>
                      <p class="mb-3 ar-sl-disclosure text-left" >
                        <strong></strong>
                      </p>
                    </section>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <section class="notice-form-date-fl">
                      <p class="mb-3 ar-sl-disclosure" >   <strong>
                        Service Fee Charges:</strong></p>
                      <p class="mb-3 ar-sl-disclosure" >
                        Excess Line Tax (3.60%)
                      </p>
                      <p class="mb-3 ar-sl-disclosure" >
                        Stamping Fee
                      </p>
                      <p class="mb-3 ar-sl-disclosure" >
                        Broker Fee (1)
                      </p>
                      <p class="mb-3 ar-sl-disclosure" >
                        Inspection Fee (1)
                      </p>
                      <p class="mb-3 ar-sl-disclosure" >
                        Other Expenses (specify) (1)
                      </p>

                    </section>
                  </div>
                  <div class="col-md-6">
                    <section class="notice-form-date-fl">
                      <p class="mb-3 ar-sl-disclosure text-left" > <br /></p>
                      <p class="mb-3 ar-sl-disclosure text-left" >
                        <strong>{{ '$' }}</strong>
                      </p>
                      <p class="mb-3 ar-sl-disclosure text-left" >
                        <strong>Included Above</strong>
                      </p>
                      <p class="mb-3 ar-sl-disclosure text-left" >
                        $
                      </p>
                      <p class="mb-3 ar-sl-disclosure text-left" >
                        $
                      </p>

                      <p class="mb-3 ar-sl-disclosure text-left" >
                        <strong></strong>
                      </p>
                    </section>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-2">
                    <section class="notice-form-date-fl">
                      <p class="mb-3 ar-sl-disclosure" >
                      </p>

                    </section>
                  </div>
                  <div class="col-md-8">
                    <section class="notice-form-date-fl">
                      <p class="mb-3 ar-sl-disclosure" >
                        Total Policy Cost : <strong></strong>
                      </p>

                    </section>
                  </div>
                </div>
                <div class="row">

                  <div class="col-md-8">
                    <section class="notice-form mt-3">
                      <p class="notice-form-date" style="text-align: left">Signature of Insured:</p>
                      <input
                          type="text"
                          class="orep-text-input notice-input"
                          placeholder="Type Your Name to Sign"
                          name="slDisclosureSignature"
                          v-validate="'required'"
                          @input="validateBeforeSubmit()"
                          v-model="standardApplication.slDisclosureSignature"
                      >
                      <span
                          v-show="errors.has('slDisclosureSignature')"
                          class="help is-danger form-errors text-danger"
                      >{{ errors.first('slDisclosureSignature') | filterText }}</span>
                    </section>
                  </div>
                </div>
                <p class="mb-3 ar-sl-disclosure">
                  
                    (1) = Fully earned
                  </p>
                <p class="mb-3 ar-sl-disclosure" style="margin-top: 20px">
                  
                    NYSID Form: NELP/2011
                  </p>
              </div>
            </article>
          </form>
        </div>
      </div>
    </section>
    <div>
      <div class="row">
        <div class="col-md-12">
          <section class="flex wrap bottom-section">
            <router-link :to="{name:'standard-application-7'}" class="next-btn back-btn flex mont spaced">
              <i class="fas fa-arrow-left"></i>
              Back
            </router-link>
            <article class="orep-pagination">
              <button class="pagination-dots" @click="navigateToPrev('standard-application-1')"></button>
              <button class="pagination-dots" @click="navigateToPrev('standard-application-2')"></button>
              <button class="pagination-dots" @click="navigateToPrev('standard-application-3')"></button>
              <button class="pagination-dots" @click="navigateToPrev('standard-application-4')"></button>
              <button class="pagination-dots" @click="navigateToPrev('standard-application-5')"></button>
              <button class="pagination-dots" @click="navigateToPrev('standard-application-6')"></button>
              <button class="pagination-dots" @click="navigateToPrev('standard-application-7')"></button>
              <button class="pagination-dots" @click="navigateToPrev('standard-application-8')"></button>
              <span class="pagination-dots pagination-current"></span>
            </article>
            <button
              class="next-btn mont spaced text-uppercase"
              @click="formSubmit()"
              :disabled="!state.pageSlDisclosureIsValid"
              :class="{submitDisabled: !state.pageSlDisclosureIsValid}"
            >Submit</button>
          </section>
        </div>
      </div>
    </div>
    <div v-if="!!loading"
         class="position-fixed d-flex justify-content-center align-items-center w-100 h-100 bg-dark"
         style="opacity: 0.7; top: 0; left: 0;">
      <span class="text-white" style="font-size: 16px">Processing...</span>
    </div>

  </div>
</template>

<script>
  import $ from "jquery";
  import moment from 'moment';
  import { STATUS } from "../../utils/constants";

  export default {
    name: "standard-application-6",
    data() {
      return {
        loading: false
      };
    },
    computed: {
      standardApplication() {
        return this.$store.state.standardApplication.standardApplication;
      },
      state() {
        return this.$store.state.standardApplication;
      },
      errorMsg() {
        return this.$store.state.standardApplication.errorMsg;
      }
    },
    watch: {
      errorMsg: {
        handler() {
          if (this.errorMsg) {
            this.loading = false;
            this.$notify({
              group: 'error',
              type: 'error',
              title: 'Error',
              text: this.errorMsg
            });
          }
        }
      }
    },
    methods: {
      navigateToPrev(route) {
        this.$router.push({
          name: route
        });
      },
      next(routeName) {
        this.$router.push({
          name: routeName
        });
      },
      validateBeforeSubmit() {
        this.$validator.validateAll().then(result => {
          if (result) {
            this.state.pageSlDisclosureIsValid = true;
            return;
          }
          this.state.pageSlDisclosureIsValid = false;
        });
      },

      formattedCurrentDate() {
        return moment(this.standardApplication.appraiserEsignatureDatetime).format('YYYY-MM-DD');
      },
      formSubmit() {
        this.loading = true;
        this.standardApplication.status = STATUS.Submitted;
        this.$store.dispatch('standardApplication/createSlDisclosure');
      },
      coverage() {
        switch (this.standardApplication.limitOfCoverage) {
          case '0.3M/0.6M':
            return '$300,000 / $600,000';
          case '0.5M/1M':
            return '$500,000 / $1,000,000';
          case '1M/1M':
            return '$1,000,000 / $1,000,000';
          default:
            return '$1,000,000 / $2,000,000';
        }
      },
    },


    filters: {
      filterText(x) {
        if (x !== undefined) {
          if (x.indexOf("req") !== -1) {
            return "This field is required";
          } else {
            return x.replace("_", " ");
          }
        }
      }
    },

    mounted() {
      $('html, body').animate({
        scrollTop: $('.page-content').offset().top
      }, 500);
    },

    components: {}
  };
</script>

<style scoped>
  strong {
    text-decoration: underline;
  }
  .form-inline > label {
    width: 82px;
    text-align: left;
  }
  .form-heading > p {
    font-size: 35px;
    width: 100%;
    text-align: center;
    margin: 0;
  }
  .form-errors,
  .js-input-errors {
    display: block;
    text-transform: initial;
    font-size: 13px;
    width: 90%;
    margin: auto;
    position: relative;
    top: -29px;
  }
  fieldset {
    font-size: 12px;
  }
  .logo {
    width: 150px;
    height: 45px;
    object-fit: contain;
  }
  h6 {
    font-size: 14px;
  }
  h5 {
    font-size: 16px;
  }
  .company-info-content {
    padding: 10px 30px;
    border: 1px solid black;
  }
  .fs-subtitle {
    margin: 20px 0;
    border-bottom: 2px solid black;
  }
  table.oreptable {
    font-size: 14px;
    margin-left: auto;
    margin-right: auto;
  }
  .gen-inf {
    display: flex;
    background: #eee none repeat scroll 0 0;
    font-size: 15px;
    font-weight: 700;
    margin-bottom: 20px;
    margin-top: 20px;
    padding: 7px;
    text-align: left;
    height: 30px;
    border: 1px solid black;
  }
  .underline-value {
    margin-left: 10px;
    margin-right: 40px;
    border-bottom: 1px solid black;
    margin-bottom: 15px;
    font-weight: 700;
    font-size: 14px;
  }
  .table th, .table td {
    text-align: center;
    vertical-align: middle;
  }
  .table.ar td, .table.ar th {
    border-left: 1px solid #ddd !important;
    border-top: 1px solid #ddd !important;
    border-right: 1px solid #ddd !important;
  }
  .w-20 {
    width: 20%;
  }
  .blank_th {
    width: 210px;
  }
  .footer-company-info {
    background-color: yellow;
    border: 1px solid black;
    padding: 10px 20px 40px;
  }
  .form-check-input {
    position: relative;
    margin-left: 0;
  }
  .page-content p, .page-content li {
    font-size: 15px;
  }
  .p-56, .notice-list > li, .notice-info {
    padding-right: 56px;
  }
</style>

